import React from 'react';
import Modal from 'modules/common/components/Modal';
import cx from 'classnames';
import RichText from 'modules/common/components/RichText';
import uid from 'uid';

class DocumentModal extends React.Component {
  constructor(props) {
    super(props);

    const orDefault = field => (props.current ? props.current[field] : '');

    this.state = {
      label: orDefault('label'),
      textBeforeLines: orDefault('text_before_lines'),
      textAfterLines: orDefault('text_after_lines'),
    };
  }

  onLabelChange = event =>
    this.setState({
      label: event.target.value,
    });

  onEditorChange = field => value => {
    this.setState({
      [field]: value,
    });
  };

  onSave = () => {
    const { label, textBeforeLines, textAfterLines } = this.state;

    const id = this.props.current ? this.props.current.id : uid();
    const isNew = this.props.current == null;

    this.props.onSave({
      id,
      isNew,
      label,
      text_before_lines: textBeforeLines || '',
      text_after_lines: textAfterLines || '',
      by_default: this.props.current ? this.props.current.by_default : false,
    });
  };

  render() {
    const { label, textBeforeLines, textAfterLines } = this.state;

    const buttonClassName = cx('ui approve primary button icon labeled', {
      disabled: label.length === 0,
    });

    return (
      <Modal isOpened onClose={this.props.onClose} closable>
        <div className="header">Modification</div>
        <div className="content ui form">
          <form>
            <div className="ui required field">
              <label>Libellé</label>
              <input
                type="text"
                value={label || ''}
                onChange={this.onLabelChange}
              />
            </div>
            <div className="ui field">
              <label>Texte avant les lignes de prix</label>
              <RichText
                value={textBeforeLines || ''}
                onChange={this.onEditorChange('textBeforeLines')}
              />
            </div>
            <div className="ui field">
              <label>Texte après les lignes de prix</label>
              <RichText
                value={textAfterLines || ''}
                onChange={this.onEditorChange('textAfterLines')}
              />
            </div>
          </form>
        </div>
        <div className="actions">
          <button className={buttonClassName} onClick={this.onSave}>
            <i className="icon add" />Editer
          </button>
        </div>
      </Modal>
    );
  }
}

export default DocumentModal;



// WEBPACK FOOTER //
// ./src/modules/saas/settings/components/DocumentModal.js